import React from 'react';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';

const SecondaryButton = ({
  to,
  href,
  size = 'large',
  fullWidth,
  onClick,
  variant = 'outlined',
  sx,
  children,
  ...rest
}) => {
  const linkProps = to
    ? { component: RouterLink, to }
    : href
      ? { component: 'a', href }
      : {};

  const variantSx = {
    outlined: {},
    ghost: {
      color: 'text.primary',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'action.hover'
      }
    },
    ghostDark: {
      color: '#FFFFFF',
      backgroundColor: 'rgba(255,255,255,0.08)',
      border: '1px solid rgba(255,255,255,0.16)',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.12)',
        border: '1px solid rgba(255,255,255,0.24)'
      }
    }
  };

  const muiVariant = variant === 'outlined' ? 'outlined' : 'text';

  return (
    <Button
      variant={muiVariant}
      color="primary"
      size={size}
      fullWidth={fullWidth}
      onClick={onClick}
      sx={{ ...variantSx[variant], ...sx }}
      {...linkProps}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
